import { useId, useState } from 'react'
import { lerNumeroRisco, produtosPorOnu } from '../../../dominio/produtos'

/**
 * O aluno digita o que leu no painel laranja e vê o que cada número diz.
 * Funciona com qualquer número de risco; a busca pelo ONU só acha os
 * produtos do catálogo de ensino, e diz isso quando não acha.
 */
export function LeitorPainel({ numeroInicial = '', onuInicial = '' }: { numeroInicial?: string; onuInicial?: string }) {
  const [numero, setNumero] = useState(numeroInicial)
  const [onu, setOnu] = useState(onuInicial)
  const idNumero = useId()
  const idOnu = useId()
  const leitura = numero.trim() ? lerNumeroRisco(numero) : null
  const onuValido = /^\d{4}$/.test(onu.trim())
  const encontrados = onuValido ? produtosPorOnu(Number(onu)) : []

  return (
    <div className="grupo-controle leitor-painel">
      <span className="titulo-controle">Ler o painel de segurança</span>
      <div className="leitor-painel__painel" aria-hidden="true">
        <span>{numero.trim() || '—'}</span>
        <span>{onu.trim() || '—'}</span>
      </div>
      <label className="campo" htmlFor={idNumero}>
        Número de risco (em cima)
        <input id={idNumero} inputMode="text" maxLength={4} value={numero} onChange={(e) => setNumero(e.target.value)} placeholder="ex.: 23, X423" />
      </label>
      <label className="campo" htmlFor={idOnu}>
        Número ONU (embaixo)
        <input id={idOnu} inputMode="numeric" maxLength={4} value={onu} onChange={(e) => setOnu(e.target.value.replace(/\D/g, ''))} placeholder="ex.: 1075" />
      </label>

      {leitura && (
        <div className={`leitor-painel__resultado${leitura.valido ? '' : ' leitor-painel__resultado--erro'}`} role="status">
          <strong>
            {!leitura.valido ? 'Não é um número de risco válido' : leitura.especial ? leitura.resumo : 'Leitura algarismo a algarismo'}
          </strong>
          {leitura.valido ? (
            <ul>
              {leitura.riscos.map((risco) => <li key={risco}>{risco}</li>)}
            </ul>
          ) : (
            <p>{leitura.resumo}</p>
          )}
        </div>
      )}
      {onuValido && (
        <p className="leitor-painel__onu" role="status">
          {encontrados.length > 0
            ? `ONU ${onu}: ${encontrados.map((p) => `${p.nome} (guia GRE ${p.guiaGre.valor})`).join('; ')}`
            : `ONU ${onu} não está no catálogo de ensino — consulte a lista do GRE/ABIQUIM.`}
        </p>
      )}
    </div>
  )
}
